import { styled } from '@mui/material/styles'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Chip,
  Button,
  Menu,
  MenuItem,
} from '@mui/material'

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 16,
    maxWidth: 800,
    width: '100%',
    margin: theme.spacing(2),
    background: 'rgba(255, 255, 255, 0.98)',
    backdropFilter: 'blur(20px)',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      borderRadius: 12,
    },
  },
}))

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5, 2),
  },
}))

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: `${theme.spacing(2.5, 3)} !important`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5, 1.5),
  },
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}))

export const InfoSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  background: theme.palette.grey[50],
  borderRadius: 12,
  border: `1px solid ${theme.palette.grey[200]}`,
  height: '100%',
}))

export const InfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  minHeight: 32,
}))

export const Label = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 14,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  minWidth: 120,
}))

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 14,
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}))

export const ProcedureChip = styled(Chip)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 500,
  borderRadius: 6,
  background: theme.palette.primary.light,
  color: theme.palette.primary.dark,
  marginRight: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
  height: 24,
}))

export const TimelineScroller = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  overflowX: 'auto',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(0.5),
  maxWidth: '100%',
  '&::-webkit-scrollbar': {
    height: 4,
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.grey[200],
    borderRadius: 2,
  },
}))

export const TimelinePill = styled(Box)<{ active?: boolean }>(
  ({ theme, active }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 8,
    background: active ? theme.palette.primary.light : theme.palette.grey[100],
    color: active ? theme.palette.primary.dark : theme.palette.text.secondary,
    fontSize: 12,
    fontWeight: 500,
    border: active ? `1.5px solid ${theme.palette.primary.main}` : 'none',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    transition: 'all 0.2s ease',
  })
)

// New styled components for inline styles
export const AgeText = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}))

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(2),
}))

export const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  textTransform: 'none',
  fontWeight: 500,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}))

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 10,
    minWidth: 180,
    boxShadow: `
      0 0 0 1px rgba(0, 0, 0, 0.03),
      0 4px 24px rgba(0, 0, 0, 0.06),
      0 8px 48px rgba(0, 0, 0, 0.04)
    `,
    backdropFilter: 'blur(20px)',
    background: 'rgba(255, 255, 255, 0.98)',
    marginTop: 6,
    '& .MuiList-root': {
      padding: '6px 0',
    },
  },
}))

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: 13.5,
  fontWeight: 500,
  padding: '8px 14px',
  margin: '0 6px',
  borderRadius: 8,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  letterSpacing: '-0.01em',
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: `${theme.palette.primary.main}08`,
    transform: 'translateY(-0.5px)',
  },
  '&:active': {
    backgroundColor: `${theme.palette.primary.main}12`,
    transform: 'translateY(0)',
  },
}))

export const LabelWithMargin = styled(Label)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}))

export const StatusLabel = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.text.primary,
}))

export const StatusTime = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
}))
